import { createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { useCountDown } from "ahooks";
import "./index.scss";
export interface CountdownProps extends ComponentBase.Component {
  duration: number;
  onFinish?: () => void;
}
export const Countdown = ({
  duration,
  onFinish
}: CountdownProps) => {
  const b = createBEM("countdown");
  const placeZero = (n: number): string => String(n < 10 ? `0${n}` : n);
  const [, formattedRes] = useCountDown({
    leftTime: duration,
    onEnd: onFinish
  });
  const {
    hours,
    minutes,
    seconds
  } = formattedRes;
  return <span className={b()} data-sentry-component="Countdown" data-sentry-source-file="index.tsx">
      {placeZero(hours)}:{placeZero(minutes)}:{placeZero(seconds)}
    </span>;
};